import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "@tameeni/shared-logic";
import inputVariants from "../input/input-variants.js";
const TextArea = React.forwardRef(
  ({ className, isInvalid, ...props }, ref) => {
    const { root, input, label } = inputVariants({ error: isInvalid });
    return /* @__PURE__ */ jsxs("div", { className: cn(root({ class: "h-24" }), className), children: [
      /* @__PURE__ */ jsx(
        "textarea",
        {
          id: "textarea",
          className: input({
            class: "p-0 h-5xl self-end"
          }),
          ref,
          ...props,
          placeholder: " "
        }
      ),
      /* @__PURE__ */ jsx("label", { htmlFor: "textarea", className: label(), children: props.placeholder })
    ] });
  }
);
TextArea.displayName = "TextArea";
export {
  TextArea
};
